import React, { useContext, useEffect } from "react";
import { useState } from "react";
import "../../Tabels/Tabels.css";
import { Link } from "react-router-dom";
import { Context } from "../../../utils/context";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { Controller } from "react-hook-form";
import Select from "react-select";

// *******************toster****************************
import ModalSave from "../../common/ModelSave";
import { CancelButton, SaveButton } from "../../common/Button";

import { Row, Col, Form, InputGroup, Modal } from "react-bootstrap";
import { useForm } from "react-hook-form";
import classNames from "classnames";
import { Select2Data } from "../../../utils/common";
import { getData } from "../../../utils/api";
library.add(fas);

const AddOffCanvance = (props) => {
    const { postData } = useContext(Context);
    const [showModal, setShowModal] = useState({
        code: 0,
        message: "",
    });

    const {
        register,
        handleSubmit,
        watch,
        control,
        getValues,
        formState: { errors },
        clearErrors,
    } = useForm();
    const imageFile = watch("image");

    const [productreviews, setProductreviews] = useState([]);

    const [ratingProducts, setRatingProducts] = useState([]);

   

    const loadRatingProducts = async () => {
        const res = await getData("/admin/masters/product-ratings");
        if (res?.success) setRatingProducts(res.data);
    };

    useEffect(() => {
        loadRatingProducts();
    }, []);

const ratingArray = ratingProducts?.data || [];

const productDropdown = ratingArray.map((rp) => ({
    label: rp?.Product?.name,
    value: rp?.id,          // this is product_rating_id
    product_id: rp?.product_id,
    product_rating_id: rp?.id
}));

// console.log(productDropdown,"productDropdownproductDropdown")

const onSubmit = async (data) => {
  
    try {
        const finalData = new FormData();     
        const selected = productDropdown.find(
            (item) => item.value === data.product_rating_id?.value
        );
        if (!selected) {
            return;
        }
        // Save product_rating_id (value)
        finalData.append("product_rating_id", selected.value);
        finalData.append("name", data?.name);
        finalData.append("description", data?.description);
        finalData.append("image", data?.image?.[0]);
        finalData.append("alt_tag", data?.alt_tag?.trim() || "");

          const response = await postData(`/admin/masters/product-reviews`, finalData);
        if (response?.success) {
        await setShowModal({ code: response?.code, message: response?.message });
        } else {
            await setShowModal({ code: response?.code, message: response?.message });
        }
        
       setTimeout(() => {
        setShowModal(0);
        props.handleClose();
      }, 1000);

      

    } catch (error) {
    }
};

    const [imagePreview, setImagePreview] = useState(null); // State to store image preview

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                setImagePreview(reader?.result); // Set image preview
            };
            reader.readAsDataURL(file);
            clearErrors("image")
        }
    };

    return (
        <>
            <Modal
                {...props}
                onHide={props.handleClose}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        Add Product Review
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form onSubmit={() => handleSubmit(onSubmit)} role="form">
                        <Row className="">

                            <Col md={6}>
                                <div className="main-form-section mt-3">
                                    <Form.Group>
                                        <Form.Label>Product</Form.Label>

                                        <InputGroup>
                                            <Controller
                                                name="product_rating_id"
                                                control={control}
                                                rules={{ required: "Please select a product" }}
                                                render={({ field }) => (
                                                    <Select
                                                        options={productDropdown || []}
                                                        onChange={(val)=> field.onChange(val)}
                                                        value={productreviews.find(opt => opt.value === field.value?.value)}
                                                        placeholder="Select Product"
                                                    />
                                                )}
                                            />
                                        </InputGroup>

                                        {errors.product_rating_id && (
                                            <span className="text-danger">
                                                {errors.product_rating_id.message}
                                            </span>
                                        )}
                                    </Form.Group>
                                </div>
                            </Col>


                            <Col md={6}>
                                <div className="main-form-section mt-3">
                                    <Form.Group>
                                        <div className="">
                                            <Form.Label>Name</Form.Label>
                                        </div>
                                        <InputGroup>
                                            <Form.Control
                                                type="text"
                                                name="Name"
                                                placeholder="name"
                                                className={classNames("", {
                                                    "is-invalid": errors?.name,
                                                })}
                                                {...register("name", {
                                                    required: "Name is required",
                                                    validate: (value) =>
                                                        value.length <= 200 ||
                                                        "Data must be 200 characters or less",
                                                })}
                                            />
                                        </InputGroup>
                                        {errors.name && (
                                            <span className="text-danger">{errors?.name?.message}</span>
                                        )}
                                    </Form.Group>
                                </div>
                            </Col>

                            <Col md={6}>
                                <div className="main-form-section mt-3">
                                    <Form.Group>
                                        <div className="">
                                            <Form.Label>Description</Form.Label>
                                        </div>
                                        <InputGroup>
                                            <Form.Control
                                                type="text"
                                                name="description"
                                                placeholder="description"
                                                className={classNames("", {
                                                    "is-invalid": errors?.description,
                                                })}
                                                {...register("description", {
                                                    required: "description is required",
                                                    validate: (value) =>
                                                        value.length <= 200 ||
                                                        "Data must be 200 characters or less",
                                                })}
                                            />
                                        </InputGroup>
                                        {errors.description && (
                                            <span className="text-danger">{errors?.description?.message}</span>
                                        )}
                                    </Form.Group>
                                </div>
                            </Col>

                            <Col md={6}>
                                <div className="main-form-section mt-3">
                                    <Form.Group>
                                        <div className="">
                                            <Form.Label>Image</Form.Label>
                                        </div>
                                        <InputGroup>
                                            <Form.Control
                                                type="file"
                                                name="image"
                                                placeholder="Image"
                                                className={classNames("", {
                                                    "is-invalid": errors?.image,
                                                })}
                                                {...register("image", {
                                                    required: "Image is required",
                                                })}
                                                accept="image/*"
                                                onChange={handleImageChange}
                                            />
                                        </InputGroup>
                                        {errors.image && (
                                            <span className="text-danger">
                                                {errors.image.message}
                                            </span>
                                        )}
                                    </Form.Group>

                                    {imagePreview && (
                                        <div className="mt-2">
                                            <img
                                                src={imagePreview}
                                                alt="Category Preview"
                                                style={{ maxWidth: "100px" }}
                                            />
                                        </div>
                                    )}
                                    <Form.Group className="mt-3">
                                        <Form.Label>Alt Tag</Form.Label>
                                        <Form.Control
                                            type="text"
                                            name="alt_tag"
                                            placeholder="Alt Tag"
                                            {...register("alt_tag")}
                                        />
                                    </Form.Group>
                                </div>
                            </Col>

                            <Row className="mt-5 pb-3">
                                <div className="d-flex justify-content-center">
                                    <Link>
                                        <CancelButton
                                            name={"cancel"}
                                            handleClose={props.handleClose}
                                        />
                                    </Link>

                                    <SaveButton
                                        name={"save"}
                                        handleSubmit={handleSubmit(onSubmit)}
                                    />
                                </div>
                            </Row>
                        </Row>
                    </Form>
                </Modal.Body>
            </Modal>

            <ModalSave
                message={showModal.message}
                showErrorModal={showModal.code ? true : false}
            />
        </>
    );
};

export default AddOffCanvance;
